var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", { staticClass: "title-text" }, [_vm._v("多选得分设置")]),
      _c("el-tooltip", { attrs: { placement: "right", effect: "light" } }, [
        _c("div", { attrs: { slot: "content" }, slot: "content" }, [
          _vm._v(
            " 1、全选对才得分，少选错选不得分：只有学生填凃的结果与标准答案完全一致才得分"
          ),
          _c("br"),
          _vm._v(" 2、选对但不全，得（）分："),
          _c("br"),
          _vm._v(" ● 全选对，得满分 ● 错选，不得分 ● 选对但不全，得设置的得分"),
          _c("br"),
          _vm._v(" 3、按选项得分，一个选项（）分："),
          _c("br"),
          _vm._v(
            " ● 全选对，得满分 ● 错选，不得分 ● 选对但不全，每选对一个得设置的得分"
          ),
          _c("br"),
          _vm._v(" 4、多种答案组合：可以设置不同选项组合对应的得分"),
          _c("br"),
          _vm._v(" 5、断句题型："),
          _c("br"),
          _vm._v(
            " ● 全选对，得满分 ● 超过规定的填凃数量，不得分 ● 选对1个，得设置的得分 "
          ),
        ]),
        _c("span", { staticClass: "el-icon-question" }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }